import { AnalyticsData, AnalyticsUserData } from 'models/Analytics';
import { CustomerAuthLevel } from 'models/Customer';
import { AppThunkAction } from 'models/Store';
import { EnhancedWindow } from 'models/Window';
import { selectAuthLevel, selectCustomerInfo } from 'store/customer';

import { selectAnalyticsData } from './analytics.selectors';
import { setCampaignAnalytics, setUserAnalytics, setView } from './analytics.slice';

export function updateUserAnalytics(): AppThunkAction {
  return function (dispatch, getState) {
    const state = getState();
    const customerInfo = selectCustomerInfo(state);
    const authLevel = selectAuthLevel(state);
    const userData: AnalyticsUserData = {
      apcn: 'null',
      loginStatus: 'anonymous',
    };

    switch (authLevel) {
      case CustomerAuthLevel.AUTHENTICATED:
        userData.apcn = customerInfo?.apcn || 'null';
        userData.loginStatus = 'logged in';
        break;
      case CustomerAuthLevel.KNOWN:
        userData.loginStatus = 'known';
        break;
      default:
    }

    dispatch(setUserAnalytics(userData));
  };
}

export function trackPageView(view: string): AppThunkAction {
  return function (dispatch, getState) {
    dispatch(setView(view));
    const state = getState();
    const analyticsData = selectAnalyticsData(state);
    track('tool-track-navigate', analyticsData);
    dispatch(setCampaignAnalytics({}));
  };
}

export function trackInteraction(interaction: string): AppThunkAction {
  return function (dispatch, getState) {
    const state = getState();
    const analyticsData = JSON.parse(JSON.stringify(selectAnalyticsData(state)));
    analyticsData.component.track.interaction = interaction;
    track('tool-track-interact', analyticsData);
  };
}

function track(trackId: string, analyticsObject: AnalyticsData) {
  try {
    (window as EnhancedWindow).analytics = analyticsObject;
    (window as EnhancedWindow)._satellite?.track(trackId);
  } catch (error) {
    console.error('Analytics Service: Error tracking page event:', trackId, analyticsObject);
  }
}
